import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { useEarningsQuantities } from "../useEarningsQuantities";
import { requestCancelEarnings } from "./cancelEarnings.request";

export const useCancelEarnings = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const { refetch: refetchEarningsQuantities } = useEarningsQuantities({
    enabled: false
  });

  return useMutation({
    mutationFn: requestCancelEarnings,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchEarningsQuantities();
      options?.onSuccess?.(data, variables, context);
    }
  });
};
